import { SignatureEnvelopeStatus } from '@commenda/prisma';
import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { SignatureEnvelope } from './types';

export interface UseSignaturesFilters {
  companyId?: number | null;
  corporationId?: number | null;
  serviceRequestId?: string | null;
  agentFirmId?: string | null;
  /** Filter by envelope status. Omit for all statuses. */
  statuses?: SignatureEnvelopeStatus[];
}

export interface UseSignaturesOptions {
  refreshInterval?: number;
}

export const useSignatures = (
  filters: UseSignaturesFilters,
  options: UseSignaturesOptions = {}
) => {
  const hasFilters =
    filters.companyId != null ||
    filters.corporationId != null ||
    filters.serviceRequestId != null ||
    filters.agentFirmId != null;

  const params = new URLSearchParams();
  if (filters.companyId != null)
    params.set('companyId', String(filters.companyId));
  if (filters.corporationId != null)
    params.set('corporationId', String(filters.corporationId));
  if (filters.serviceRequestId != null)
    params.set('serviceRequestId', filters.serviceRequestId);
  if (filters.agentFirmId != null)
    params.set('agentFirmId', filters.agentFirmId);
  if (filters.statuses?.length)
    params.set('statuses', filters.statuses.join(','));

  const query = params.toString();
  const url = hasFilters
    ? `e-signature/envelopes${query ? `?${query}` : ''}`
    : null;

  const { data, error, mutate } = useSWR<SignatureEnvelope[]>(
    url,
    SWRFetcher({ method: 'GET' }),
    { refreshInterval: options.refreshInterval ?? 0 }
  );

  return {
    envelopes: data,
    error,
    mutate,
    isLoading: !data && !error,
  };
};
